import utils from 'analytics/utils';
import anaConsts from 'analytics/constants';
import deepExtend from 'utils/deepExtend';
import basketUtils from 'utils/Basket';
import skuUtils from 'utils/Sku';
import locationUtils from 'utils/Location';

export default function (data) {
    const currentEvent = utils.getMostRecentEvent(anaConsts.LINK_TRACKING_EVENT);
    const { sku, analyticsData = {} } = data;
    const {
        containerTitle, productId, isAddFullSize, isBIRBReward, personalizedInternalCampaign
    } = analyticsData;
    const isHomepageRewardCarousel = locationUtils.isHomepage() && containerTitle === anaConsts.CAROUSEL_NAMES.REWARD_BAZAAR;

    /* ILLUPH-119839
     * According to JIRA and business, requirement is to have prop55 populate with
     * actionCampaignString listed below only for the products within the
     * purchases carousel on the profile lists page. (loves and services cannot have rewards)
     * On other pages we will continue to populate eVar75 with actionCampaignString.
     */
    const addText = isAddFullSize ? 'add-full-size' : isHomepageRewardCarousel ? 'add to basket' : 'add-to-basket';
    const isBiReward = skuUtils.isBiReward(sku);
    let actionInfo = isBIRBReward || isBiReward ? [containerTitle, addText].join(':') : addText;
    let internalCampaign = addText;
    let actionCampaignString;

    if (containerTitle) {
        actionCampaignString = `${containerTitle}:${sku.productId || productId}:${addText}`;

        if (isHomepageRewardCarousel) {
            actionCampaignString = `sephora carousel:${containerTitle}:n/a`;
        }

        if (containerTitle === anaConsts.CAROUSEL_NAMES.PURCHASES) {
            actionInfo = actionCampaignString;
        } else {
            internalCampaign =
                isBIRBReward && !isHomepageRewardCarousel
                    ? `${containerTitle}:${sku.productId || productId}:${addText.split(' ').join('-')}`
                    : actionCampaignString;
        }
    }

    if (personalizedInternalCampaign) {
        internalCampaign = personalizedInternalCampaign;
    }

    deepExtend(currentEvent, {
        eventInfo: {
            attributes: {
                biRealTimePointStatus: basketUtils.getAvailableBiPoints(),
                biRewardType: sku.biType,
                actionInfo,
                linkName: isAddFullSize ? 'Add Full Size' : 'Add To Basket',
                internalCampaign
            }
        }
    });
}
